import React, { createContext, useState, useEffect } from 'react';
import { useGlobalState } from '../hooks';
import { COLOR_THEME } from '../helpers';

export const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState(localStorage.getItem('colorTheme') || COLOR_THEME.LIGHT);

  const [userSettings, setUserSettings] = useGlobalState('userSettings');

  // Get theme from user settings
  useEffect(() => {
    const colorTheme = userSettings?.COLOR_THEME?.user_setting_value;

    if (colorTheme && theme !== colorTheme) {
      setTheme(colorTheme);

      // Persist theme in local storage
      localStorage.setItem('colorTheme', colorTheme);
    }
  }, [userSettings]);

  // Apply theme
  useEffect(() => {
    const applyTheme = () => {
      let activeTheme = theme;
      if (theme === COLOR_THEME.AUTO) {
        activeTheme = window.matchMedia('(prefers-color-scheme: dark)').matches
          ? COLOR_THEME.DARK
          : COLOR_THEME.LIGHT;
      }
      document.documentElement.setAttribute('data-theme', activeTheme);
    };

    applyTheme();

    if (theme === COLOR_THEME.AUTO) {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

      const handleChange = e => {
        applyTheme();
      };

      mediaQuery.addEventListener('change', handleChange);

      // Clean up
      return () => mediaQuery.removeEventListener('change', handleChange);
    }
  }, [theme]);

  return <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>;
};
